var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('header.news')))]),_c('h3',[_vm._v("工事中")])])
}
var staticRenderFns = []

export { render, staticRenderFns }